import { combineReducers } from '@reduxjs/toolkit';

import notificationsReducer from './slices/notificationsSlice';
import generalReducer from './slices/generalSlice';
import assistanceReducer from './slices/assistanceSlice';

const rootReducer = combineReducers({
  general: generalReducer,
  assistance: assistanceReducer,
  notifications: notificationsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
